<template>
  <v-container fluid>
      <v-btn-toggle v-model="index">
          <v-btn>
              To Do
          </v-btn>
          <v-btn>
              Archiv
          </v-btn>
      </v-btn-toggle>
  </v-container>
</template>

<script>

export default {
  name: 'CreditTransferPaymentRunFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      index: 0,
      map: [
        {
          "exists[processed_at]": "false"
        },
        {
          "exists[processed_at]": "true"
        },
      ]
    };
  },
  watch: {
    index(v) {
      if (v !== null) {
        this.item = {...this.map[v]};
      }
    },
    values(v) {
      this.index = null;
      for (const k in v) {
        const i = this.map.findIndex(e => e.hasOwnProperty(k) && e[k] === v[k]);
        if (i !== -1) {
          this.index = i;
        }
      }
    }
  },
  computed: {
    // eslint-disable-next-line
    item: {
      get() {
        return this.initialValues || this.values;
      },
      set(v) {
        this.$emit('update:values', v);
      }
    }
  },
  methods: {
  }
};
</script>
